export async function fetchConfig() {
  const attempt_limit = 3
  for (let attempt = 1; attempt <= attempt_limit; attempt++) {
    try {
      const resp = await fetch("/config.json")
      return await resp.json()
    } catch (err) {
      if (attempt === attempt_limit) {
        throw err
      }
    }
  }
}
